// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://87b3c7a2c9cf45958d49488ede93d841@o1030302.ingest.sentry.io/6114979',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  logLevel: 1,
  environment: process.env.NEXT_ENV || 'development',
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
